import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import type { ShippingCountriesAPIResponse } from 'typings'
import { useFetch } from './useFetch'

export function useShippingCountries(
  options?: Partial<UseQueryOptions<string[]>>
) {
  const { fetcherWrapper } = useFetch()

  const url = new URL(
    `/api/proxy/logistics/pub/shipping/configuration`,
    window.location.origin
  )

  async function fetcher() {
    return fetcherWrapper(url.toString())
      .then((r) => r.json())
      .then((response: ShippingCountriesAPIResponse) => response.shipsTo ?? [])
  }

  return useQuery<string[]>({
    queryKey: ['logistics-shipping-countries'],
    queryFn: fetcher,
    ...options,
  })
}
